/** 聚意宝 **/
import CpsRepository from '@/repositories/cps/index';
const cpsRepository = new CpsRepository()
/** 营销中心 **/
import MarketRepository from '@/repositories/market/index';
const marketRepository = new MarketRepository()
/** 用户信息 **/
import UserRepository from '@/repositories/user/index';
const userRepository = new UserRepository()
/** 发票 **/
import InvoiceRepository from '@/repositories/invoice/index';
const invoiceRepository = new InvoiceRepository()
/** 红包 */
import RedpacketRepository from '@/repositories/redpacket/index';
const redpacketRepository = new RedpacketRepository()
/** 带客金 **/
import VirtualCurrencyRepository from '@/repositories/virtualCurrency/index';
const virtualCurrencyRepository = new VirtualCurrencyRepository()

/**钱包 */
import WalletRepository from '@/repositories/wallet/index';
const walletRepository = new WalletRepository()

/**推广 */
import ExtensionRepository from '@/repositories/extension/index';
const extensionRepository = new ExtensionRepository()
/** 服务类推广 */
import ServicePromotionRepository from '@/repositories/servicePromotion/index';
const servicePromotionRepository = new ServicePromotionRepository()
/**高峰日 */
import PeakDaySettingRepository from '@/repositories/peakDaySetting/index';
const peakDaySettingRepository = new PeakDaySettingRepository()
/**首页**/
import HomeRepository from '@/repositories/home/index';
const homeRepository = new HomeRepository()
/**通知**/
import AdNoticeRepository from '@/repositories/adNotice/index';
const adNoticeRepository = new AdNoticeRepository()

import FreeRoomApplyOrderRepository from './FreeRoomApplyOrder';
const freeRoomApplyOrderRepository = new FreeRoomApplyOrderRepository()

import CampaignInsuranceRepository from '@/repositories/campaignInsurance/index';
const campaignInsuranceRepository = new CampaignInsuranceRepository()

export {
    campaignInsuranceRepository,
    freeRoomApplyOrderRepository,
    extensionRepository,
    cpsRepository,
    marketRepository,
    userRepository,
    invoiceRepository,
    redpacketRepository,
    virtualCurrencyRepository,
    walletRepository,
    servicePromotionRepository,
    peakDaySettingRepository,
    homeRepository,
    adNoticeRepository,
}